import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FormSubmitFunction } from "lib/form";
import { createEmpty } from "lib/locale";
import { FieldOptionInterface } from "models/list-entity-field";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useLocales } from "stores/hooks/locale";
import * as yup from "yup";

interface FieldOptionFormProps {
  existingValues: string[];
  option?: FieldOptionInterface;
  onSubmit: FormSubmitFunction;
  onClose: () => Promise<void>;
}

const FieldOptionForm: FunctionComponent<FieldOptionFormProps> = (props) => {
  const locales = useLocales();

  const {
    existingValues,
    option = {
      value: Date.now(),
      text: createEmpty("Uusi vaihtoehto", locales),
    },
    onSubmit,
    onClose,
  } = props;

  const schema = yup
    .object({
      text: yup.object().validateLocaleString(),
      value: yup.string().validateRequired().validateNotOneOf(existingValues),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      value: option.value,
      text: option.text,
    },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton },
  ];

  const handleSubmit = async (values: any) => {
    onSubmit(values);
  };

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            <TextInput
              required
              name="text"
              label="Vaihtoehdon teksti"
              translations
            ></TextInput>
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInput
              required
              name="value"
              label="Vaihtoehdon tunniste"
            ></TextInput>
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default FieldOptionForm;
